module.exports = __webpack_public_path__ + "static/media/session6.d30e726d.svg";